import React, { useEffect, useState } from "react";
import "./ConfirmacaoEmail.css";

import { AuthShell } from "../../../components/AuthShell";
import { LoadingButton } from "../../../components/loadingButtom";
import { confirmaEmailVerificandoSender, handleReenviar } from "./functions";

import { useNavigate } from "react-router-dom";
import { FiAlertTriangle, FiCheckCircle, FiMail } from "react-icons/fi";

const ConfirmacaoEmail = () => {
  const [confirmado, setConfirmado] = useState<boolean>(false);
  const [erro, setErro] = useState<boolean>(false);
  const [reenviar, setReenviar] = useState<boolean>(false);
  const [erroReenviar, setErroReenviar] = useState<boolean>(false);

  const navigate = useNavigate();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const email = urlParams.get("Email") ?? "";
  const sender = urlParams.get("Sender");
  const token = urlParams.get("Token") ?? "";
  const tipo = urlParams.get("Tipo") ?? "";

  useEffect(() => {
    confirmaEmailVerificandoSender(sender ?? "", email, token, setConfirmado, setErro)
  }, [email, sender, token]);

  return (
    <AuthShell
      eyebrow="Confirmação"
      title="E-mail Omex"
      subtitle="Validação de acesso para manter sua conta protegida no ambiente Omex Capital."
      onLogoClick={() => navigate("/")}
    >
      <section className="auth-card cliente-confirmation-card">
        {!confirmado ? (
          <>
            <div className="cliente-confirmation-icon loading">
              <LoadingButton />
            </div>
            <h2>Confirmando seu e-mail</h2>
            <p>Aguarde enquanto validamos o link de confirmação.</p>
          </>
        ) : erro ? (
          <>
            <div className={`cliente-confirmation-icon ${reenviar ? "success" : "error"}`}>
              {reenviar ? <FiMail /> : <FiAlertTriangle />}
            </div>
            {reenviar ? (
              <>
                <h2>E-mail reenviado</h2>
                <p>Verifique sua caixa de entrada e use o novo link de confirmação.</p>
              </>
            ) : (
              <>
                <h2>Não foi possível confirmar</h2>
                <p>Clique abaixo para reenviar a confirmação para o seu e-mail.</p>
                {erroReenviar && (
                  <p className="auth-message">Algo deu errado. Aguarde alguns instantes e tente novamente.</p>
                )}
                <button
                  className="auth-primary-button"
                  type="button"
                  onClick={() => handleReenviar(email, tipo, setReenviar, setErroReenviar)}
                >
                  Reenviar confirmação
                </button>
              </>
            )}
          </>
        ) : (
          <>
            <div className="cliente-confirmation-icon success">
              <FiCheckCircle />
            </div>
            <h2>E-mail confirmado</h2>
            {sender === "sys" ? (
              <>
                <p>Seu acesso foi confirmado. Retorne ao login para entrar na plataforma.</p>
                <button className="auth-primary-button" type="button" onClick={() => navigate("/")}>
                  Acessar plataforma
                </button>
              </>
            ) : (
              <p>Retorne à tela de login do app e entre utilizando as credenciais cadastradas.</p>
            )}
          </>
        )}
      </section>
    </AuthShell>
  );
};

export default ConfirmacaoEmail;
